function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "App_Rounded",
  "data-name": "App Rounded"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_7",
  "data-name": "Rectangle 7",
  width: 1240,
  height: 1240,
  rx: 212,
  fill: "#fff"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_68",
  "data-name": "Group 68",
  transform: "translate(8493 15918.246)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_67",
  "data-name": "Group 67",
  transform: "translate(1373 1419.754)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_9",
  "data-name": "Path 9",
  d: "M696.023,435.05a53.522,53.522,0,0,0-11.481-14.574A55.114,55.114,0,0,0,667.414,410.3a57.053,57.053,0,0,0-20.647-3.818H392.641V772.974h83.37v-112.8H646.767a57.351,57.351,0,0,0,20.647-3.818,52.92,52.92,0,0,0,17.128-10.487,58.485,58.485,0,0,0,11.481-14.531,34.088,34.088,0,0,0,4.314-16.631v-162.8A35.437,35.437,0,0,0,696.023,435.05ZM617.35,491v88.649c0,.27-.156.6-.184.88-.5,5.846-2.526,10-6.131,12.388a17.082,17.082,0,0,1-9.508,2.441h-125.9V472.784h125.9c8.685,0,13.723,4.087,15.255,12.1.1.582.241,1.149.326,1.8.014.184.014.411.043.61.1,1.022.2,2.086.2,3.221Z",
  transform: "translate(-9758.163 -17250.484)",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_53",
  "data-name": "Path 53",
  d: "M475.336,291.164H437.256a37.662,37.662,0,0,0-16.756,3.863,45.981,45.981,0,0,0-14.187,10.582c-.746.789-1.335,1.809-2.024,2.685q-11.006,12.664-11.731,30.426c-.057.8-.143,1.594-.143,2.426V497.455a50.732,50.732,0,0,0,3.891,19.6c.273.617.618,1.177.933,1.809.431.962.919,1.9,1.45,2.829a51.7,51.7,0,0,0,7.624,11.286A46.078,46.078,0,0,0,420.5,543.588c5.313,2.57,11.6,4.968,17.445,4.968H626.876v25.9c0,11.3-5.628,16.958-16.943,16.958H476.844v66.236H659.916c13.985,0,25.917-3.862,35.666-11.544q14.625-11.587,14.632-32.594V291.164ZM626.547,404.009v59.057c0,11.616-5.184,17.948-15.522,17.948L560.267,481H492.337c-10.339,0-15.493-4.753-15.493-16.4V376.038q0-17.511,15.493-17.532H611.025q15.507,0,15.522,17.532Z",
  transform: "translate(-10115.415 -17135.164)",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_62",
  "data-name": "Group 62",
  transform: "translate(-9018.56 -16844)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_50",
  "data-name": "Path 50",
  d: "M466.047-198.412H435.495a36.18,36.18,0,0,0-14.728,3.586,46.339,46.339,0,0,0-13.789,10.317,51.367,51.367,0,0,0-9.819,15.625,48.482,48.482,0,0,0-3.828,19.126V55.428h82.023V-115.307c0-11.868,5.28-17.845,15.8-17.845H643.057v-65.26Z",
  transform: "translate(-393.33 198.412)",
  fill: "currentColor"
}))));

function SvgAppIconGprInsights(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_70",
    "data-name": "Group 70",
    xmlns: "http://www.w3.org/2000/svg",
    width: 1240,
    height: 1240,
    viewBox: "0 0 1240 1240",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppIconGprInsights);
export default __webpack_public_path__ + "static/media/appIconGPRInsights.2fe5b7e3.svg";
export { ForwardRef as ReactComponent };